import {
  GDPR,
  INTRO_PAGE,
  VALIDATE_PHONE,
  VERIFICATION_CODE,
  FACE_CAPTURE,
  FACE_CAPTURE_INSTRUCTIONS,
  FACE_CAPTURE_CONFIRM,
  DOCUMENT_CAPTURE_INSTRUCTIONS,
  DOCUMENT_CAPTURE_PORTRAIT,
  DOCUMENT_CAPTURE_CONFIRM,
  THANK_YOU,
  VERIFY_IDENTITY,
  DOCUMENT_COUNTRY_SELECTOR,
  LIVENESS_TEST,
  INSTRUCTIONS_CLR,
  INSTRUCTIONS_FACE_LIVENESS_3D,
  FACE_LIVENESS_3D,
} from "./enums/pages";

export const steps = [
  //0 Welcome
  [INTRO_PAGE, GDPR],
  //1 Create application
  [VALIDATE_PHONE, VERIFICATION_CODE],
  //2 Face capture
  [FACE_CAPTURE_INSTRUCTIONS, FACE_CAPTURE, FACE_CAPTURE_CONFIRM],
  //3 Document capture
  [
    DOCUMENT_COUNTRY_SELECTOR,
    VERIFY_IDENTITY,
    DOCUMENT_CAPTURE_INSTRUCTIONS,
    DOCUMENT_CAPTURE_PORTRAIT,
    DOCUMENT_CAPTURE_CONFIRM,
  ],
  //4 Liveness test (clr)
  [INSTRUCTIONS_CLR, LIVENESS_TEST],
  //4 Liveness test (3dfl)
  [INSTRUCTIONS_FACE_LIVENESS_3D, FACE_LIVENESS_3D],
  //5 Submit
  [THANK_YOU],
];

//TODO@gva refactor step logic so it complies to nonlinear page movement
export function getStepAndIndex(currentPage, step) {
  if (!steps[step]) {
    step = getPageStep(currentPage);
    if (step < 0)
      throw Error("Cannot find page " + currentPage + " in form steps");
  }
  let index = steps[step].indexOf(currentPage);
  if (index === -1) throw Error("Cannot find page in steps array");
  return { step, index };
}

export function previous(currentPage, currentStep) {
  const { step, index } = getStepAndIndex(currentPage, currentStep);
  return steps[step][index - 1] || (step && steps[step - 1][0]) || INTRO_PAGE;
}

export function next(currentPage, currentStep) {
  const { step, index } = getStepAndIndex(currentPage, currentStep);
  return (
    steps[step][index + 1] ||
    (steps.length > step && steps[step + 1][0]) ||
    INTRO_PAGE
  );
}

export function getPageStep(page) {
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].includes(page)) {
      return i;
    }
  }
  return -1;
}
